// Kept in its own module (no imports from ./index) so consumers like
// module-terminology can use it without creating a circular dependency.
const APEX_PRODUCT_NAME = 'apex academy';

/**
 * Whether a course's product is an Apex product. Matches by substring
 * (case-insensitive) so name variations like "Apex Academy Test" also match.
 * Single matcher reused by getSessionCardVariant and the module terminology.
 */
export const isApexProduct = (productName?: string): boolean =>
  productName?.toLowerCase().includes(APEX_PRODUCT_NAME) ?? false;
